var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.493,
    height: 20.53,
    viewBox: "0 0 20.493 20.53",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_feather-phone",
    "data-name": "Icon feather-phone",
    d: "M21.659,16.872v2.789a1.86,1.86,0,0,1-2.027,1.86,18.4,18.4,0,0,1-8.024-2.854A18.13,18.13,0,0,1,6.03,13.088,18.4,18.4,0,0,1,3.175,5.027,1.86,1.86,0,0,1,5.026,3H7.815a1.86,1.86,0,0,1,1.86,1.6,11.938,11.938,0,0,0,.651,2.613,1.86,1.86,0,0,1-.418,1.962L8.726,10.354A14.876,14.876,0,0,0,14.3,15.933l1.181-1.181a1.86,1.86,0,0,1,1.962-.418,11.938,11.938,0,0,0,2.613.651,1.86,1.86,0,0,1,1.6,1.887Z",
    transform: "translate(-2.167 -2)",
    fill: "none",
    stroke: "#19c3b9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.abd6a95d283486500204426b1321c12c.svg";
export { ForwardRef as ReactComponent };